// extracted by mini-css-extract-plugin
export default {"innerWrapper":"es-z","tooltipWrapper":"fs-z","icon":"gs-z","tooltip":"hs-z","content":"is-z"};